export default {
    CREATE_UserAssignBoard: () => '/userBoard/createUserBoard',
    GET_ALL_UserAssignBoard: () => '/userBoard/getAllUserBoard',
    DELETE_UserAssignBoard: (id) => `/userBoard/deleteUserBoard/${id}`,
    UPDATE_UserAssignBoard: (id) => `/userBoard/updateUserBoard/${id}`,
    GET_UserAssignBoard_ID: (id) => `/userBoard/getUserBoardBy/${id}`,
    GET_UserBoard_ID: (id) => `/auth/getUserById/${id}`,
    GET_ASSIGN_USER_BY_BOARD_ID :(id,search,falsePagination,page) =>`/userBoard/getUserByBoard/${id}?search=${search || ''}&falsePagination=${falsePagination||"false"}&page=${page || 1}`
};
